import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  UpdateTenderStateMutation,
  UpdateTenderStateMutationVariables,
  UpdateTenderStateDocument,
} from "@/graphql/__generated__/graphql";

export default function useUpdateTenderStateMutationHook(): {
  updateTenderStateMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [updateTenderStateMutation, { loading, error }] = useMutation<UpdateTenderStateMutation, UpdateTenderStateMutationVariables>(
    UpdateTenderStateDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "tender-state-updated-success",
          data: {
            title: t("toasts.taskupdated"),
            type: "success",
          },
        });
      },
    });

  return {
    updateTenderStateMutation,
    loading,
    error,
  };
}
